import { useMemo } from "react";
import type { TaskQueryParams } from "@/types/list";

/**
 * Builds TaskQueryParams for a subtask list.
 * Use this to provide values to TaskQueryParamsProvider when rendering subtasks.
 */
export function useSubtaskQueryParams(parentTaskId: number): TaskQueryParams {
    return useMemo<TaskQueryParams>(
        () => ({ type: "subtasks", taskListId: undefined, filter: undefined, completedTasks: "all", parentTaskId }),
        [parentTaskId]
    );
}
